class TabTrap {
  constructor (element) {
    this.$root = element
  }

  initEvents () {
    this.focusableElements =
      'button:not(aria-hidden), [href]:not(aria-hidden), input, select, textarea, [tabindex]:not([tabindex="-1"])'
    this.firstFocusableElement = this.$root.querySelectorAll(
      this.focusableElements
    )[0]
    this.focusableContent = this.$root.querySelectorAll(this.focusableElements)
    this.lastFocusableElement =
      this.focusableContent[this.focusableContent.length - 1]
    this.bindedFunction = this.handleKeyUp.bind(this)
    document.addEventListener('keydown', this.bindedFunction)
    this.firstFocusableElement.focus()
  }

  destroyEvents () {
    document.removeEventListener('keydown', this.bindedFunction)
  }

  handleKeyUp (e) {
    if (e.key !== 'Tab') {
      return
    }

    if (
      e.shiftKey &&
      document.activeElement.isEqualNode(this.firstFocusableElement)
    ) {
      e.preventDefault()
      this.lastFocusableElement.focus()
    } else if (document.activeElement.isEqualNode(this.lastFocusableElement)) {
      this.firstFocusableElement.focus()
      e.preventDefault()
    }
  }
}

export default TabTrap
